import React from 'react'
import dompurify from 'dompurify'
import './modal.scss'

function Modal(props) {
  return (
    <div className={`modal-container${props.open ? ' open' : ''}`}>
      <div className="modal">
        <div className="modal-header">
          <h3 className="modal-title">{props.title}</h3>
          <button onClick={props.toggleModal} className="close-modal">
            &times;
          </button>
        </div>
        <div className="modal-content">
          {props.data !== undefined ? (
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: dompurify.sanitize(props.data) }}
            />
          ) : (
            'Data missing'
          )}
        </div>
      </div>
      <div className="background" onClick={props.toggleModal} />
    </div>
  )
}

export default Modal
